import React, { FunctionComponent } from 'react'
import Svg, { Path } from 'react-native-svg'

import { useTheme } from 'styled-components/native'

import { AuroraThemeType } from '../../utils/themes/ThemeProvider'

type Props = {
  size?: number | string
}

export const AuroraCoachingSecondaryRecIllustration: FunctionComponent<Props> = ({ size = 64 }) => {
  const { colors } = useTheme() as AuroraThemeType
  const { spotIllustration } = colors.icons

  return (
    <Svg width={size} height={size} viewBox='0 0 64 64' fill='none'>
      <Path
        d='M52.9271 44.6038C56.0044 37.5364 55.7979 27.1585 51.3459 20.7368C48.256 16.2795 42.1912 12.8357 36.8847 12.2591C31.3434 11.6568 25.4426 12.1145 20.5775 14.9961C16.3021 17.5275 12.6872 21.3038 10.7118 25.9603C9.43644 28.9687 8.86575 32.2808 9.02655 35.5527C9.34815 42.0933 12.323 48.7977 17.7855 52.3555C24.3832 56.6537 33.3061 58.4559 40.7944 55.6563C45.4151 53.9296 50.7263 49.6554 52.9255 44.6038H52.9271Z'
        fill={spotIllustration.secondary.fill}
      />
      <Path
        d='M48.6856 33.2267C49.2783 41.0217 44.4369 49.0898 35.194 50.4615C19.8279 52.7392 9.05415 36.6399 20.0849 24.0647C29.5344 13.2901 47.5663 18.5281 48.6856 33.2267Z'
        fill={spotIllustration.primary.fill}
      />
      <Path
        d='M32.3217 45.5522C38.0211 45.5522 42.6414 40.8448 42.6414 35.0378C42.6414 29.2309 38.0211 24.5234 32.3217 24.5234C26.6222 24.5234 22.002 29.2309 22.002 35.0378C22.002 40.8448 26.6222 45.5522 32.3217 45.5522Z'
        fill={spotIllustration.secondary.fill}
      />
      <Path
        d='M32.3208 39.3076C34.6359 39.3076 36.5127 37.3954 36.5127 35.0366C36.5127 32.6778 34.6359 30.7656 32.3208 30.7656C30.0057 30.7656 28.1289 32.6778 28.1289 35.0366C28.1289 37.3954 30.0057 39.3076 32.3208 39.3076Z'
        fill={spotIllustration.primary.fill}
      />
      <Path
        d='M32.9129 34.2362L20.8597 15.5481C20.5748 15.1062 19.9922 14.9834 19.5585 15.2738L19.5572 15.2747C19.1235 15.565 19.003 16.1586 19.288 16.6004L31.3411 35.2886C31.6261 35.7304 32.2086 35.8532 32.6423 35.5629L32.6436 35.562C33.0773 35.2716 33.1978 34.6781 32.9129 34.2362Z'
        fill={spotIllustration.secondary.fill}
      />
      <Path
        d='M20.5072 7L26.3071 16.08L24.212 22.2833L24.2104 22.2865H24.2072L17.7925 21.7243L11.9941 12.6443L18.7305 13.706L20.5072 7Z'
        fill={spotIllustration.primary.fill}
      />
    </Svg>
  )
}
